export default __webpack_public_path__ + "3a2349b881476b99c64b145d033b0ece.png";